export interface INotaryCommission {
  id: string;
  state: string;
  county: string;
  commissionNo: string;
  commissionPeriod: string[];
  thumbnail?: string[];
}

export enum ExtraFieldStatus {
  DANGER = 'danger',
  INFO = 'info',
  DEFAULT = 'default',
  PENDING = 'pending',
  ACTIVE = 'active',
}

export enum DataCardActionType {
  REDIRECT = 'redirect',
  INTERACT = 'interact',
}

export interface IDataCardAction {
  type: DataCardActionType;
  route?: string;
  delete?: (...args: any) => void;
  edit?: (...args: any) => void;
  add?: (...args: any) => void;
}

export interface IFileInput {
  name: string;
  type: string;
  extension: string;
  path: string;
  pipeFrom: string;
  document: string;
  user: string;
}

export interface IComissionDetails {
  comissionNo: string;
  comissionPeriod: string;
  county: string;
  state: string;
}

export interface IComission {
  details: IComissionDetails;
  files: IFileInput;
  id: string;
  type: string;
}
